import { useToast } from "../components/Toast";

function execCopy(text) {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.cssText = "position:fixed;top:0;left:0;opacity:0;pointer-events:none";
  document.body.appendChild(ta);
  ta.select();
  try {
    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    document.body.removeChild(ta);
  }
}

/**
 * Copy text. Resolves true on success and calls `onDone(msg)` only then; when both the Clipboard API
 * and the execCommand fallback fail it calls `onDone("Couldn't copy: <text>")` so it can be copied by hand.
 */
async function copyText(text, onDone, msg = "Link copied") {
  let ok = false;
  try {
    await navigator.clipboard.writeText(text);
    ok = true;
  } catch {
    ok = execCopy(text);
  }
  onDone?.(ok ? msg : `Couldn't copy: ${text}`, ok);
  return ok;
}

/** Hook: const copy = useCopyText(); copy(url, "Link copied"); */
export function useCopyText() {
  const toast = useToast();
  return (text, msg = "Link copied") => copyText(text, (m, ok) => toast(m, ok ? undefined : "alert"), msg);
}
